module.exports = __webpack_public_path__ + "media/images/icon-insta-hover-95322594401cfe46a5c35359add3609f.svg";